<template>
  <loader-text :title="$t('logout.is_loading')" />
</template>

<script>
  import LoadOnNavigate from '@/mixins/load-on-navigate';
  import LoaderText from '@/components/loader-text';

  export default {
    name: 'LogoutView',
    components: {
      LoaderText,
    },
    mixins: [
      LoadOnNavigate,
    ],
    computed: {
      showcasePcieUrl() {
        return 'https://www.icdl.quebec';
      },
      monPcieUri() {
        return `${this.get().parameters.monpcie.value}/login`;
      },
    },
    methods: {
      load() {
        const accessToken = this._.get(this.oauth(), 'access_token');
        if (accessToken) {
          this.unset('oauth');
        }
        this.$test.unsetData();
        if (this.$helper.isPlayerDemo36) {
          window.location.href = this.monPcieUri;
        } else if (this.$helper.isPlayerDemo12) {
          window.location.href = this.showcasePcieUrl;
        } else {
          window.location.href = accessToken ? `${this.monPcieUri}?token=${accessToken}&player=${this.$helper.playerKind}` : this.monPcieUri;
        }
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import '~@/scss/vars';
</style>
